"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataBus = void 0;
const logic_1 = require("./logic");
/**
 * The entry point of the DataBus layer.
 */
class DataBus {
    constructor() {
        this._database = new logic_1.Database();
    }
    /**
     * Create a DataBus instance.
     */
    static create(options) {
        const { dataStorageProvider, storeProvider } = options;
        const databus = new DataBus();
        const db = databus.getDatabase();
        db.setDataStorageProvider(dataStorageProvider);
        db.setStoreProvider(storeProvider);
        return databus;
    }
    /**
     * Get the database of a DataBus instance.
     *
     * Currently, only one database exists for a DataBus instance. In the future, there may be multiple databases
     * for a DataBus instance. And the use cases are:
     *
     * - For front end, there is only one user, so one database suffice.
     * - For back end, the server creates many databases, one database corresponds to one user respectively.
     */
    getDatabase() {
        return this._database;
    }
}
exports.DataBus = DataBus;
//# sourceMappingURL=databus.js.map